import { add, update, setKey } from '@/store/common/mutations';
export default {
  add,
  update,
  setKey,
};
